// extracted by mini-css-extract-plugin
module.exports = {"photo_editor":"index--photo_editor--2P75L","photo_editor__canvas":"index--photo_editor__canvas--3LPF0"};